import { render, staticRenderFns } from "./CustomerDropdown.vue?vue&type=template&id=002b4976&scoped=true&"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b4976",
  null
  
)

export default component.exports